import React,{Component} from 'react';

import PropTypes from 'prop-types';

import { DataGrid, GridColDef, GridSortModel, GridRowId } from '@mui/x-data-grid';
import Paper from '@mui/material/Paper';
import GridToolbar from './GridToolbar';
import { Box } from '@mui/material';

const s:any = {
  root: {
    width: '100%',
    mt: 1,
  },
  tableWrapper: {
    width: '100%',
    overflow: 'hidden',
  },
  datagrid: {
    width: '100%',
    '& .MuiDataGrid-root': {
      border: 'none',
    },
    '& .MuiDataGrid-main': {
      overflowX: 'hidden',
    },
    '& .MuiDataGrid-virtualScroller': {
      overflowX: 'hidden',
    },
    '& .MuiDataGrid-virtualScrollerContent': {
      width: 'fit-content',
      minWidth: '100%',
    },
    '& .MuiDataGrid-cell': {
      padding: '0px 8px',
    },
    '& .MuiDataGrid-columnHeaders': {
      backgroundColor: 'rgba(0, 0, 0, 0.05)',
    },
  }
};

class GridPanel extends Component<any,any> {
  static propTypes: any;
  static defaultProps: any;
  constructor(props:any) {
    super(props);
    this.state = {
      sortModel: this.props.orderBy ? [{ field: this.props.orderBy, sort: this.props.order || 'asc' }] : [],
      selected: [],
      cols: props.rows.map((row:any)=>row.id),
      rows: props.rows,//this.props.rows,
      data: props.data,//this.props.data,
      page: props.page || 0,//this.props.page || 0,
      total: props.recordCount,
      rowsPerPage: props.rowsPerPage||10,//this.props.rowsPerPage||5,
      selectedRecord: null,
      selectedIndex: null,
      actions: [],
      rowSelectionModel: [] as GridRowId[],
    };
  }

  onSortModelChange = (sortModel: GridSortModel) => {
    this.setState({ sortModel });
  };

  onRowSelectionModelChange = (rowSelectionModel: GridRowId[]) => {
    const selectionArray: GridRowId[] = Array.isArray(rowSelectionModel) ? rowSelectionModel : [];
    const selectedId = selectionArray.length > 0 ? selectionArray[0] : null;
    
    if (selectedId === null) {
      this.setState({ 
        selected: [], 
        selectedRecord: null, 
        selectedIndex: null, 
        actions: [],
        rowSelectionModel: []
      });
      return;
    }

    // Find the selected row
    const row = this.props.data?.find((d:any) => d.id === selectedId);
    
    if (row && row.rid !== undefined) {
      const item = this.props.data?.find((d:any) => d.rid === row.rid);
      console.log('Actual row to display', item);

      const { actions } = this.props;
      const actype = typeof actions;
      const gridactions = Array.isArray(actions) ? actions
                        : (actype === 'function') ? actions(row?.id, item)
                        : (actype === 'object') ? Object.keys(actions)
                        : (actype === 'string') ? [actions] : [];

      this.setState({ 
        selected: [row?.rid], 
        selectedRecord: item, 
        selectedIndex: row?.id, 
        actions: gridactions,
        rowSelectionModel: selectionArray
      });
    }
  };

  onPageChange = (page: number) => {
    this.setState({ page });
  };

  onPageSizeChange = (pageSize: number) => {
    this.setState({ rowsPerPage: pageSize });
  };

  componentDidMount() {
    // Ensure rowSelectionModel is always initialized
    if (!Array.isArray(this.state.rowSelectionModel)) {
      this.setState({ rowSelectionModel: [] });
    }
  }

  componentDidUpdate(prevProps: any) {
    // Reset selection if data changes significantly
    if (prevProps.data !== this.props.data && this.state.rowSelectionModel.length > 0) {
      const currentSelection = this.state.rowSelectionModel[0];
      const exists = (this.props.data || []).some((row: any) => 
        (row.id === currentSelection) || (row.rid === currentSelection)
      );
      if (!exists) {
        this.setState({ 
          rowSelectionModel: [],
          selected: [],
          selectedRecord: null,
          selectedIndex: null,
          actions: []
        });
      }
    }
  }

  onRowSelect = (event:any, row:any) => {
    //event.preventDefault();

    //find item
    if(this.state.selectedIndex === event?.id){
      return;
    }

    const selected = this.props.data?.find((d:any) => d.rid === row?.rid);
    console.log("selected",selected)
    
    if (selected && selected.rid !== undefined) {
      const item = this.props.data?.find((d:any) => d.rid === selected.rid);
      //console.log('Actual row to display', item);

      const { actions } = this.props;
      const actype = typeof actions;
      const gridactions = Array.isArray(actions) ? actions
                        : (actype === 'function') ? actions(event?.id, item)
                        : (actype === 'object') ? Object.keys(actions)
                        : (actype === 'string') ? [actions] : [];

      this.setState({ 
        selected: [selected?.rid], 
        selectedRecord: item, 
        selectedIndex: event?.id, 
        actions: gridactions,
        //rowSelectionModel: selectionArray
      });
    }

    // if(row!==null && row.rid!==undefined){
    //   const item = this.props.data?.find((d:any)=>d.rid===row.rid);
    //   console.log('Actual row to display',item)

    //    //RSM
    // console.log("prop data",this.props?.data)
    // const rec = item;
    // //console.log('rec',rec)
    // const {actions} = this.props;
    // const actype = typeof actions;
    // const gridactions = Array.isArray(actions) ? actions
    //                   : (actype === 'function')?actions(row?.id,rec)
    //                   : (actype === 'object')?Object.keys(actions)
    //                   : (actype === 'string')?[actions]:[];
    // //
    // this.setState({ selected: [row?.rid] , selectedRecord: rec, selectedIndex:row?.id, actions: gridactions});
    // }
    
   
  };

  render() {
    const { search, query, title, sdata, rows, data, formatters, actionSet, onAction, handleSelect, refresh, setColumns, filterColumns, classes } = this.props;
    const { recordCount, pageMode, page: rempage, onPageChange: onRemotePageChange, onRowsPerPageChange: onRemoteRowsPerPageChange } = this.props;
    const { selected, selectedRecord, actions, sortModel, rowsPerPage, page: locpage, cols, rowSelectionModel } = this.state;
    
    const isRemote = (pageMode === 'remote');
    const page = isRemote ? rempage : locpage;
    const rowCount = isRemote ? recordCount : (data?.length || 0);
    const fm = formatters || {};
    const frows = filterColumns(rows, cols);
    // Ensure rowSelectionModel is always a valid array of GridRowId 
    const safeRowSelectionModel: GridRowId[] = Array.isArray(rowSelectionModel) ? rowSelectionModel : [];
    
    // Convert column definitions to DataGrid format
    const columns: GridColDef[] = frows.map((col: any) => ({
      field: col.id,
      headerName: col.label || col.id,
      width: col.width || 100,
      sortable: true,
      disablePadding: col.disablePadding || false,
      align: col.numeric ? 'right' : 'left',
      headerAlign: col.numeric ? 'right' : 'left',
      renderCell: (params: any) => {
        const value = params.value;
        const row = params.row;
        return fm[col.id] ? fm[col.id](value, row) : (value !== null && value !== undefined ? String(value) : '');
      },
    }));

    // Handle pagination
    const handlePageChange = (newPage: number) => {
      if (isRemote && onRemotePageChange) {
        onRemotePageChange(null, newPage);
      } else {
        this.onPageChange(newPage);
      }
    };

    const handlePageSizeChange = (newPageSize: number) => {
      if (isRemote && onRemoteRowsPerPageChange) {
        onRemoteRowsPerPageChange({ target: { value: newPageSize } });
      } else {
        this.onPageSizeChange(newPageSize);
      }
    };

    

    return (
      <Paper sx={{...s.root}}>
        <GridToolbar 
          title={title} 
          numSelected={selected.length} 
          selectedRecord={selectedRecord}
          handleSelect={handleSelect}
          onAction={onAction}
          refresh={refresh}
          actions={actions}
          actionSet={actionSet}
          setColumns={setColumns}
          cols={rows}
          fcols={frows}
          sdata={sdata}
        />
        <Box sx={{...s.tableWrapper, height: 600 }}>
          <DataGrid
            rows={data || []}
            columns={columns}
            getRowId={(row) => {
              if (row.id !== undefined && row.id !== null) return row.id;
              if (row.rid !== undefined && row.rid !== null) return row.rid;
              // Fallback: use index if no ID is available
              const index = (data || []).indexOf(row);
              return index >= 0 ? `row-${index}` : `row-${Math.random()}`;
            }}
            rowCount={rowCount || 0}
            pageSizeOptions={[5, 10, 25, 50, 100]}
            paginationModel={{ page, pageSize: rowsPerPage }}
            onPaginationModelChange={(model) => {
              handlePageChange(model.page);
              handlePageSizeChange(model.pageSize);
            }}
            sortModel={sortModel || []}
            onSortModelChange={this.onSortModelChange}
            //rowSelectionModel={safeRowSelectionModel}
            //onRowSelectionModelChange={this.onRowSelectionModelChange}
            onRowClick={(e)=>this.onRowSelect(e,e.row)}
            checkboxSelection
            disableMultipleRowSelection
            disableRowSelectionOnClick={false}
            hideFooterSelectedRowCount={true}
            paginationMode={isRemote ? 'server' : 'client'}
            sortingMode={isRemote ? 'server' : 'client'}
            autoHeight={false}
            sx={{ ...s.datagrid }}
          />
        </Box>
      </Paper>
    );
  }
}

GridPanel.propTypes = {
  filterColumns:PropTypes.func,
  //classes: PropTypes.object.isRequired,
  rowsPerPage: PropTypes.number,
  data: PropTypes.array.isRequired,
  rows: PropTypes.array.isRequired,
  orderBy: PropTypes.string.isRequired,
};

export default GridPanel;
